<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { real_id, get_local_ip } from '../../../../helpers/interface_helpers';
	import { onSettingsResponse } from '../../../../helpers/device_settings_helpers';
	//Services
	import { localReq, postReq } from '../../../../services/http';
	//Stores
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Design system components
	import { Button } from '@Shelly/shelly-design-system';
	//Types
	import type { Device } from '../../../../types/Device';
	import { capFirstChar } from '../../../../helpers/utilities';

	export let device: Device;

	const id = real_id(device.id);
	let waitForResponse = false;

	$: statusStore = getDeviceStatus(id);
	$: value = $statusStore?.valves[0]?.state || 'loading';
	$: button_value = value === 'opened' ? 'close' : 'open';

	const save = async () => {
		waitForResponse = true;
		let res;
		const local_ip = get_local_ip(id);
		if (local_ip) {
			res = await localReq(device, `${local_ip}/valve/0`, 'post', {
				go: button_value,
			});
		} else {
			res = await postReq(`/device/generic_command`, {
				id,
				command: 'valve',
				payload: JSON.stringify({ go: button_value, id: 0 }),
			});
		}
		onSettingsResponse(res, device);
		waitForResponse = false;
	};
</script>

<Button size="m" width="full" on:click={save} loading={waitForResponse} disabled={value.includes('ing')}
	>{capFirstChar(
		$format(`button_${button_value}_valve`, {
			default: `${button_value} valve`,
		}),
	)}</Button
>
